import React from 'react'

import cm from './PlayerFrame.module.css'

interface PlayerFrameProps {
  children: React.ReactNode
}

export const PlayerFrame = React.forwardRef<HTMLDivElement, PlayerFrameProps>(
  (props: PlayerFrameProps, ref) => {
    return (
      <div className={cm.mnchBlueStripe}>
        <div className={cm.backgroundWrapper}>
          <div className={cm.dots} />
          <div className={cm.footer} />
        </div>
        <div className={cm.contentWrapper} ref={ref}>
          <div className={cm.embedContainer}>{props.children}</div>
        </div>
        <div className={cm.description}>
          <div className={cm.content}>
            <a href="https://manychat.com" className={cm.link}>
              Manychat
            </a>{' '}
            is simple & powerful chatbot platform
          </div>
        </div>
      </div>
    )
  },
)
